import { getLanAdapterAddress, isLanAdapter } from '@/plugins/lan-adapter'

const stateKeys = ['current-installation']

export const state = () => ({
  // Session only: installation ids that show the "new" tag on the remote support menu item.
  remoteSupportNewIds: []
})

export const mutations = {
  addRemoteSupportNew(state, installationId) {
    if (!state.remoteSupportNewIds.includes(installationId)) {
      state.remoteSupportNewIds.push(installationId)
    }
  },
  clearRemoteSupportNew(state, installationId) {
    state.remoteSupportNewIds = state.remoteSupportNewIds.filter(
      (id) => id !== installationId
    )
  }
}

export const actions = {
  clearStorage({ dispatch }) {
    dispatch('maintenance/clearStorage', null, {
      root: true
    })

    for (let i = 0; i < stateKeys.length; i++) {
      this.$storage.removeUniversal(stateKeys[i])
    }
  },
  getCurrent() {
    return this.$storage.getUniversal('current-installation')
  },
  setCurrent({ dispatch }, installation) {
    this.$storage.setUniversal('current-installation', installation)
    dispatch('maintenance/setByInstallation', installation, {
      root: true
    })
  },
  clearCurrent() {
    this.$storage.removeUniversal('current-installation')
  },
  // Pessimistic update: the stored state only changes after the API confirms.
  async setRemoteSupportEnabled({ dispatch }, { installationId, enabled }) {
    const response = await this.$marlonApi.setRemoteSupportEnabled(
      installationId,
      enabled
    )
    if (response?.success) {
      await dispatch(
        'account/setRemoteSupportEnabled',
        { installationId, enabled },
        { root: true }
      )
    }
    return response
  },
  generateInstallationIdentifier(_, units) {
    const priorityOrder = ['indoor', 'outdoor', 'lan_adapter', 'tank']

    const unit = priorityOrder
      .map((type) => units.find((unit) => unit.type === type))
      .find(Boolean)

    if (!unit) return ''
    // A LAN adapter can have no model and no serial, only a MAC address
    if (isLanAdapter(unit)) {
      return `${unit.material || ''}-${getLanAdapterAddress(unit)}`
    }
    return `${unit.material}-${unit.serial}`
  }
}
